<template>
    <div class="podcast-book-selector">
        <SearchInput
            ref="search"
            :placeholder="$t('podcasts.episodes.searchBook')"
            class="podcast-book-selector__search"
            @change="onSearch"
        />
        <Spinner v-if="loading" />
        <ul class="podcast-book-selector__list">
            <li
                v-for="book in books"
                :key="book.id"
                v-tooltip="book.name"
                class="podcast-book-selector__book"
                :class="{ unselected: modelValue && modelValue !== book.id }"
                @click.prevent="select(book)"
            >
                <img
                    class="podcast-book-selector__book-cover"
                    :src="book.preview_img_site"
                    :alt="book.name"
                />
            </li>
            <li v-if="canLoadMore" class="podcast-book-selector__loadmore">
                <button class="button" type="button" @click="loadmore">
                    {{ $t('misc.loadmore') }}
                </button>
            </li>
        </ul>
        <input :value="modelValue" name="book" type="text" class="visually-hidden" required />
    </div>
</template>

<script>
import { SearchInput } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'PodcastBookSelector',
    components: {
        SearchInput
    },
    props: {
        modelValue: {
            type: [Number, String],
            default: undefined
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            books: [],
            count: 0,
            pageSize: 20,
            searchString: '',
            page: 1,
            loading: false
        };
    },
    computed: {
        canLoadMore() {
            return this.page * this.pageSize < this.count;
        }
    },
    mounted() {
        this.fetchBooks();
    },
    methods: {
        async fetchBooks() {
            try {
                this.loading = true;

                const params = {
                    page_size: this.pageSize,
                    page: this.page,
                    ordering: '-id'
                };

                if (this.searchString) {
                    params.search = this.searchString;
                }

                // TODO move to api layer
                const { results, count } = await this.$http.get('/api/v2/books/', { params });

                if (this.page > 1) {
                    this.books = [...this.books, ...results];
                    return;
                }

                this.books = results;
                this.count = count;
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        loadmore() {
            this.page = this.page + 1;
            this.fetchBooks();
        },
        onSearch(searchString) {
            this.searchString = searchString;
            this.page = 1;
            this.fetchBooks();
        },
        select(book) {
            this.$emit('update:modelValue', book.id);
        },
        clearBook() {
            this.$emit('update:modelValue', undefined);
        }
    }
};
</script>

<style src="./PodcastBookSelector.scss" lang="scss"></style>
